import React from 'react'
import LocationLabel from '../../locations/label'
import DateLabel from '../../date/numerical'
import DurationLabel from '../../durations/label'
import HourLabel from '../../hours/label'
import AbsentIndicator from './absent-indicator'
import PresentIndicator from './present-indicator'
import MessageButton from './message-button'
import FacilitatorLabel from '../../facilitators/label'
import AutoEnrolledIndicator from './auto-enrolled-indicator';
import { Card, useAccordionToggle, Accordion } from 'react-bootstrap'

const UserCourse = ({
    course = {},
    userId,
}) => {
    console.log('course:', course)
    const toggle = useAccordionToggle(course.id)
    return (
        <Card>
            <Card.Header style={{ padding: '5px' }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row'
                }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            flexGrow: 1,
                            cursor: 'pointer'
                        }}
                        onClick={toggle}
                    >
                        <div className='ellipsis-truncate'>
                            <DateLabel value={course.date} /> | <HourLabel hourId={course.hourId} /> | <DurationLabel durationId={course.durationId} />
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: '5px',
                        }}
                    >
                        <AutoEnrolledIndicator course={course} userId={userId} />
                        <AbsentIndicator course={course} userId={userId} />
                        <PresentIndicator course={course} userId={userId} />
                        <MessageButton course={course} userId={userId} />
                    </div>
                </div>
            </Card.Header>
            <Accordion.Collapse eventKey={course.id}>
                <Card.Body>
                    <div className='ellipsis-truncate'>{course.name}</div>
                    <div className='ellipsis-truncate'>
                        Facilitator: <FacilitatorLabel facilitatorId={course.facilitatorId} />
                    </div>
                    <div className='ellipsis-truncate'>
                        Location: <LocationLabel locationId={course.locationId} />
                    </div>
                    <div className='ellipsis-truncate'>
                        Units: {course.credits}
                    </div>
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    )
}

export default UserCourse